import { render, staticRenderFns } from "./editPrice.vue?vue&type=template&id=bfaf8180&scoped=true&"
import script from "./editPrice.vue?vue&type=script&lang=js&"
export * from "./editPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaf8180",
  null
  
)

export default component.exports